<section class="jumbotron">
  <div class="container position-relative">
    <div class="jumbotron-content text-white text-center">
      <h1 class="font-weight-bolder text-title-header">{{'header.solution' | translate}}</h1>
      <a [routerLink]="['/solucion/ambiental']">
        <img src="../../../assets/img/SOLUCIÓN/01.svg" alt="">
      </a>
      <a [routerLink]="['/solucion/industrial']">
        <img src="../../../assets/img/SOLUCIÓN/02.svg" alt="">
      </a>
    </div>
  </div>
</section>

<section>
  <div class="container py-4">
    <p class="text-center mb-5 p-subtitle">{{'solution.text' | translate}}</p>
    <div class="row p-0 m-0 justify-content-md-center">
      <div class="col-lg-2">
      </div>
      <div class="col-lg-4">
        <div class="item-img-hover" style="background: url(../../../assets/img/SOLUCIÓN/04.png);">
          <div class="content-item-img">
              <a class="btn custom-cta" [routerLink]="['/solucion/ambiental']">{{'app.see_more' | translate}}</a>
          </div>
        </div>
        <div class="item-img-text text-center pt-3">
          <p>{{'header.environment' | translate}}</p>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="item-img-hover" style="background: url(../../../assets/img/SOLUCIÓN/INDUSTRIAL/lidar-dron.jpg);">
          <div class="content-item-img">
              <a class="btn custom-cta" [routerLink]="['/solucion/industrial']" >{{'app.see_more' | translate}}</a>
          </div>
        </div>
        <div class="item-img-text text-center pt-3">
          <p>{{'header.industrial' | translate}}</p>
        </div>
      </div>
        <div class="col-lg-2">
        </div>
    </div>
  </div>
</section>
